import { render, staticRenderFns } from "./OrdersPersonGroupShow.vue?vue&type=template&id=6dc183a1&"
import script from "./OrdersPersonGroupShow.vue?vue&type=script&lang=js&"
export * from "./OrdersPersonGroupShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports